import React from 'react';

import { ReactComponent as Icon } from 'assets/img/vectors/user.svg';

const UserIcon = ({ fill, ...props }) => (
   <Icon {...props} fill={(fill ? fill : 'rgba(0,0,0,0)')} />
);

export default UserIcon;
